import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=c399544e&scoped=true&"
import script from "./Video.vue?vue&type=script&lang=ts&"
export * from "./Video.vue?vue&type=script&lang=ts&"
import style0 from "./Video.vue?vue&type=style&index=0&id=c399544e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c399544e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
